const PREFIX = 'pill_review_draft:';
export function readReviewDraft(uuid) {
    try { return JSON.parse(sessionStorage.getItem(PREFIX + uuid)) || {}; } catch { return {}; }
}
export function saveReviewDraft(uuid, draft) {
    try {
        if (draft?.content) sessionStorage.setItem(PREFIX + uuid, JSON.stringify(draft));
        else sessionStorage.removeItem(PREFIX + uuid);
    } catch { /* Storage can be unavailable in private WebViews. */ }
}
export function clearReviewDrafts() {
    try {
        Object.keys(sessionStorage).filter(key => key.startsWith(PREFIX)).forEach(key => sessionStorage.removeItem(key));
    } catch {}
}
